// @flow
import { QueryClient } from 'react-query';

const queryClient: QueryClient = new QueryClient();

export default queryClient;
